/* eslint-disable react/jsx-pascal-case */
import {
  Col,
  DatePicker,
  ConfigProvider,
  Form,
  Input,
  Row,
  Button,
  Select,
  Space,
  Card,
  Divider,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import React, { useEffect, useState, useRef } from "react";
// import Label_language from '../../language'
import UploadImg from "../../utility/UploadImg";
import JoditEditor from "jodit-react";
const { ConfigContext } = ConfigProvider;

const WebsiteBasicInformationForm = ({
  propsForm = null,
  formReloadCount = 0,
  selectOption = [],
  onFormFinish = () => { },
}) => {
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const [files, setFiles] = useState([]);
  const [communityData, setCommunityData] = useState([]);
  const setFormValuesOtherThings = (formValues) => {
    //做一些你可能會用到其他component的資料整理
    let newFormValues = {
      ...formValues,
      total: formValues?.comments * formValues?.number || 0,
    };
    if (propsForm) {
      propsForm.setFieldsValue(newFormValues);
    } else {
      form.setFieldsValue(newFormValues);
    }
  };

  const onChangeFileValue = (values) => {
    let file = values?.file ?? [];
    setFiles(file);
  };
  const setDataInitialization = () => {
    //拿個下拉選單等等的資訊
    // getNewsTypeOption()
    // getNewsWeightTypeOption()
  };
  const onFinish = (values) => {
    let news_time = dayjs(values?.news_time).format("YYYY-MM-DD HH:mm:ss");
    let announce_time_end = dayjs(values?.announce_time_end).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    console.log(values.information_community_data);
    onFormFinish({
      ...values,
      news_time,
      announce_time_end,
    });
    form.resetFields();
  };
  const onReset = () => {
    form.resetFields();
  };
  const onValuesChange = () => {
    let formValues = null;
    if (propsForm) {
      formValues = propsForm.getFieldsValue();
    } else {
      formValues = form.getFieldsValue();
    }
    setFormValuesOtherThings(formValues);
  };
  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < dayjs().subtract(1, "day").endOf("day");
  };
  const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };

  const disabledDateTime = (current) => ({
    disabledHours: () => {
      let hour = dayjs().format("HH");
      let todayDate = dayjs().format("YYYY-MM-DD");
      let currentDate = dayjs(current).format("YYYY-MM-DD");
      if (todayDate === currentDate) {
        return range(0, 24).splice(0, parseInt(hour));
      } else {
        return range(0, 24).splice(0, 0);
      }
    },
    disabledMinutes: () => {
      let minutes = dayjs().format("mm");
      let hour = dayjs().format("HH");
      let todayDate = dayjs().format("YYYY-MM-DD");
      let currentDate = dayjs(current).format("YYYY-MM-DD");
      let currentHour = dayjs(current).format("HH");
      console.log({ minutes });
      if (todayDate === currentDate && currentHour === hour) {
        return range(0, 60).splice(0, parseInt(minutes) + 5);
      } else {
        return range(0, 0);
      }
    },
    disabledSeconds: () => {
      return range(0, 0);
    },
  });

  useEffect(() => {
    setDataInitialization();
  }, []);
  useEffect(() => {
    let formValues = null;
    if (propsForm) {
      formValues = propsForm.getFieldsValue();
    } else {
      formValues = form.getFieldsValue();
    }
    // setFormValuesOtherThings(formValues)
    onChangeFileValue(formValues);
  }, [formReloadCount]);

  return (
    <Row gutter={[10, 20]} justify="space-around" style={{ padding: "3vmin" }}>
      <Col span={24}>
        <Form
          // labelCol={{ span: 6 }}
          // wrapperCol={{ span: 18 }}
          layout="vertical"
          form={propsForm ? propsForm : form}
          onValuesChange={onValuesChange}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Row gutter={[8, 8]} style={{ justifyContent: "end" }}>
            {/* <Col span={24} > */}
            {/* <Form.Item> */}
            {/* <Row gutter={[8, 8]} > */}

            <Col>
              {/* <Button htmlType="button" onClick={onReset} size="large"> */}
              <Button htmlType="button" size="large">
                清除
              </Button>
            </Col>
            <Col>
              <Button type="primary" htmlType="submit" size="large">
                送出
              </Button>
              {/* </Col>
                            </Row> */}
              {/* </Form.Item> */}
            </Col>
          </Row>
          <Row gutter={[8, 8]}>
            <Col lg={8} md={24} sm={24} xs={24}>
              <Row justify={"center"}>
                <Col span={24}>
                  <Form.Item hidden name="information_id"></Form.Item>
                  <Form.Item label="聯絡人" name="contact_person">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item hidden name="information_id"></Form.Item>
                  <Form.Item
                    label="電話"
                    name="phone"
                    rules={[
                      {
                        required: true,
                        message: "請輸入電話",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="地址"
                    name="address"
                    // style={{ minWidth: '300px' }}
                    rules={[
                      {
                        required: true,
                        message: "請輸入地址",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="電子信箱"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "格式錯誤",
                        type: "email",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col lg={16} md={24} sm={24} xs={24}>
              <Row justify={"center"} gutter={[20, 20]}>
                <Col lg={20} md={24} sm={24} xs={24}>
                  <Form.Item
                    label={"Google Map iframe"}
                    name={"google_map_iframe"}
                  // rules={[
                  //     {
                  //         required: true,
                  //         message: "請輸入"
                  //     }
                  // ]}
                  >
                    <TextArea rows={6} allowClear />
                  </Form.Item>
                </Col>

                <Col lg={20} md={24} sm={24} xs={24}>
                  <Form.Item
                    label={"Google Map 預覽"}
                  // name={"googleMapIframePreview"}
                  // rules={[
                  //     {
                  //         required: true,
                  //         message: "請輸入"
                  //     }
                  // ]}
                  >
                    {/* <TextArea rows={6} allowClear /> */}
                    {/* {console.log(Form.useWatch('google_map_iframe', propsForm))} */}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: (
                          Form.useWatch("google_map_iframe", propsForm) || ""
                        ).replace(
                          `width="600" height="450"`,
                          `width="100%" height="100%"`
                        ),
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={[8, 8]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Divider orientation="left">網站圖片</Divider>
              <Form.List name="classify_structure_type_data">
                {(fields, { add, remove }) => (
                  <Row gutter={[8, 32]} justify={"left"}>
                    {console.log(fields)}
                    {fields.map((field) => (
                      <>
                        <Form.Item
                          name={[field.name, "classify_structure_type_id"]}
                          hidden
                        >
                          <Input></Input>
                        </Form.Item>
                        <Form.List
                          name={[
                            field.name,
                            "classify_structure_type_file_data",
                          ]}
                        >
                          {(subFields, subOpt) => subFields.length ?
                            subFields.map((subField) => (
                              <Col lg={12} md={24} sm={24} xs={24}>
                                <Form.Item
                                  // label={propsForm.getFieldValue([`classify_structure_type_data`, field.name, 'title'])}
                                  // name={`${field.title}`}
                                  name={[subField.name, "file_id"]}
                                  hidden
                                  initialValue={[]}
                                >
                                  <Input></Input>
                                </Form.Item>
                                <Form.Item
                                  label={propsForm.getFieldValue([
                                    `classify_structure_type_data`,
                                    field.name,
                                    "title",
                                  ])}
                                // name={`${field.title}`}
                                // name={[field.name, 'title']}
                                >
                                  <UploadImg
                                    defaultValue={propsForm.getFieldValue([
                                      `classify_structure_type_data`,
                                      field.name,
                                      "classify_structure_type_file_data",
                                    ])}
                                    onImagesChange={(files) => {
                                      // let file = {}
                                      const file = [files.findLast(() => true)] || [];
                                      // file = item
                                      propsForm.setFieldValue(
                                        [
                                          `classify_structure_type_data`,
                                          field.name,
                                          "classify_structure_type_file_data",
                                        ],
                                        file
                                      );
                                    }}
                                  />
                                </Form.Item>
                              </Col>
                            ))
                            :
                            <Col lg={12} md={24} sm={24} xs={24}>
                              <Form.Item
                                // label={propsForm.getFieldValue([`classify_structure_type_data`, field.name, 'title'])}
                                // name={`${field.title}`}
                                name={[0, "file_id"]}
                                hidden
                                initialValue={[]}
                              >
                                <Input></Input>
                              </Form.Item>
                              <Form.Item
                                label={propsForm.getFieldValue([
                                  `classify_structure_type_data`,
                                  field.name,
                                  "title",
                                ])}
                              // name={`${field.title}`}
                              // name={[field.name, 'title']}
                              >
                                <UploadImg
                                  onImagesChange={(files) => {
                                    // let file = {}
                                    const file = [files.findLast(() => true)] || [];

                                    // file = item
                                    propsForm.setFieldValue(
                                      [
                                        `classify_structure_type_data`,
                                        field.name,
                                        "classify_structure_type_file_data",
                                      ],
                                      file
                                    );
                                  }}
                                />
                              </Form.Item>
                            </Col>
                          }

                        </Form.List>
                      </>
                    ))}
                    {/* <Col span={24}>
                                                    <Button type="dashed" onClick={() => add()} block>
                                                        + 新增分類
                                                    </Button>
                                                </Col> */}
                  </Row>
                )}
              </Form.List>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Divider orientation="left">網站社群設定</Divider>

              {/* <Card
                style={{
                  background: "#F7F7F7",
                  borderRadius: "15px",
                  boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.25)",
                }}
              > */}
              <Form.List name="information_community_data">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: "flex",
                          marginBottom: 8,
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[
                            name,
                            "information_community_id",
                          ]}
                          hidden
                        >
                          <Input />
                        </Form.Item>
                        {/* <Sugopic img={iconPic[key]} style={{ height: '48px' }} /> */}
                        <Form.Item
                          {...restField}
                          name={[name, "community_id"]}
                          rules={[
                            {
                              required: true,
                              message: "請勿空白",
                            },
                          ]}
                        >
                          {/* {  console.log("selectOptionItem", selectOption)} */}

                          <Select
                            style={{ width: 200 }}
                            //   options={
                            //       iconData
                            //   }
                            //   onChange={(e) =>
                            //       choose(
                            //           e,
                            //           form
                            //               .getFieldValue(`data`)
                            //               .map((tmp) => tmp.icon),
                            //           key
                            //       )
                            //   }
                            options={
                              selectOption &&
                              selectOption.map(
                                (selectOptionItem, selectOptionIndex) => {
                                  // console.log("selectOptionItem", selectOptionItem)
                                  return {
                                    ...selectOptionItem,
                                    value: selectOptionItem.community_id,
                                    label: selectOptionItem.name,
                                  };
                                }
                              )
                            }
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "link"]}
                          rules={[
                            {
                              required: true,
                              message: "請勿空白",
                            },
                          ]}
                        >
                          <Input placeholder="網址" />
                        </Form.Item>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        新增
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              {/* </Card> */}
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default WebsiteBasicInformationForm;
